<ng-container *ngIf="!isInsideModal">

<app-breadcrumb [title]="'menu.companies' | translate" [showTrail]="false"></app-breadcrumb>

</ng-container>

<!--company info -->

<div class="container-fluid basic_table">
    <div class="row">
<div class="col-sm-12">
    <div class="card">
      <!-- Card Header -->
      <div class="card-header company-card-header">
        <div class="company-header-actions">
          <button [hidden]="user_type == 200 || user_type == 201 || !canAddCompanyAllowed" class="btn btn-dark-custom" (click)="openXl(content)">
            <i class="fa fa-plus-circle mx-1"></i>
            <span>{{ curentLang === 'en' ? 'Add Company' : (curentLang === 'ar' ? 'اضافة مصلحة تجارية' : 'הוספת חברה')}}</span>
          </button>

          <!-- Quota exceeded notice for merchant -->
          <div *ngIf="(user_type == 100 || user_type == 101) && !canAddCompanyAllowed" class="company-quota-notice d-flex align-items-center gap-2 px-3 py-2 rounded me-2">
            <i class="fa fa-lock text-warning"></i>
            <span class="small fw-semibold" style="color:#7a5c00;">
              {{ curentLang === 'en' ? 'Company limit reached' : (curentLang === 'ar' ? 'وصلت للحد الأقصى للمصالح تجارية' : 'הגעת למגבלת החברות') }}
            </span>
            <a [routerLink]="['/dashboard/invoice-subscriptions']" class="btn btn-sm btn-danger ms-1">
              <i class="fa fa-arrow-up me-1"></i>
              {{ curentLang === 'en' ? 'Upgrade' : (curentLang === 'ar' ? 'ترقية' : 'שדרג') }}
            </a>
          </div>
          <button [hidden]="user_type == 100 || user_type == 101" class="btn btn-dark-custom" (click)="openXl2(contentAdmin)">
            <i class="fa fa-plus-circle mx-1"></i>
            <span>{{ curentLang === 'en' ? 'Add Company' : (curentLang === 'ar' ? 'اضافة مصلحة تجارية' : 'הוספת חברה')}}</span>
          </button>
          <button [hidden]="user_type == 100 || user_type == 101" class="btn btn-dark-custom" (click)="exportAllToExcel()">
            <i class="fa fa-file-excel-o mx-1"></i>
            <span class="d-none d-sm-inline">{{ curentLang === 'en' ? 'Export Excel' : (curentLang === 'ar' ? 'تصدير اكسيل' : 'ייצוא אקסל')}}</span>
          </button>
          <button class="btn btn-outline-warning btn-refresh" (click)="refreshCompanies()">
            <i class="fa fa-refresh mx-1"></i>
            <span class="d-none d-sm-inline">{{ curentLang === 'en' ? 'Refresh' : (curentLang === 'ar' ? 'تحديث' : 'רענן')}}</span>
          </button>
        </div>
      </div>

      <!-- Admin: record type (merchant / accountant) — never 'all' on default screen -->
      <div class="company-tab-bar company-record-type-bar" *ngIf="user_type == 200 || user_type == 201">
        <button class="company-tab"
                [class.company-tab--active]="adminRecordType === 'merchant'"
                (click)="switchAdminRecordType('merchant')">
          <i class="fa fa-store me-1"></i>
          {{ curentLang === 'en' ? 'Merchant companies' : (curentLang === 'ar' ? 'مصالح تجارية التاجر' : 'חברות סוחר') }}
        </button>
        <button class="company-tab"
                [class.company-tab--active]="adminRecordType === 'accountant'"
                (click)="switchAdminRecordType('accountant')">
          <i class="fa fa-briefcase me-1"></i>
          {{ curentLang === 'en' ? 'Accountant companies' : (curentLang === 'ar' ? 'مصالح تجارية المحاسبين' : 'חברות רואי חשבון') }}
        </button>
      </div>

      <!-- Tab Bar -->
      <div class="company-tab-bar">
        <button class="company-tab" [class.company-tab--active]="activeTab === 'active'" (click)="switchTab('active')">
          <i class="fa fa-building-o me-1"></i>
          {{ curentLang === 'en' ? 'Active' : (curentLang === 'ar' ? 'النشطة' : 'פעילות') }}
          <span class="tab-count">{{ total }}</span>
        </button>
        <button class="company-tab" [class.company-tab--active]="activeTab === 'archived'" (click)="switchTab('archived')" *ngIf="shouldShowArchivedTab()">
          <i class="fa fa-archive me-1"></i>
          {{ curentLang === 'en' ? 'Archived' : (curentLang === 'ar' ? 'المؤرشفة' : 'ארכיון') }}
          <span class="tab-count" [class.tab-count--red]="archivedCount > 0">{{ archivedCount }}</span>
        </button>
      </div>

      <!-- Search Bar -->
      <div class="company-search-bar" *ngIf="activeTab === 'active'">
        <div class="search-input-wrapper">
          <i class="fa fa-search search-icon"></i>
          <input class="form-control company-search-input" type="text" name="search"
                 [ngModelOptions]="{standalone: true}" id="search" [(ngModel)]="term"
                 placeholder="{{ curentLang === 'en' ? 'Search by name or tax number…' : (curentLang === 'ar' ? 'ابحث بالاسم أو الرقم الضريبي…' : 'חפש לפי שם או מספר מס…') }}">
          <button *ngIf="term" class="search-clear-btn" (click)="term=''">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>

      <div class="card-block row">
        <div class="col-sm-12 col-lg-12 col-xl-12" *ngIf="activeTab === 'active'">

          <!-- ═══════════════════════════════════════ DESKTOP TABLE (lg+: 992px+) -->
          <div class="table-responsive d-none d-lg-block">
            <table class="table table-light text-center table-hover">
              <thead>
                <tr>
                  <th scope="col">{{ curentLang === 'en' ? '#' : (curentLang === 'ar' ? 'م' : 'מ') }}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Company Name' : (curentLang === 'ar' ? 'أسم المصلحة التجارية' : 'שם החברה')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Company type' : (curentLang === 'ar' ? 'نوع المصلحة التجارية' : 'סוג חברה') }}</th>
                  <th scope="col" *ngIf="user_type == 100 || user_type == 101">{{ curentLang === 'en' ? 'Accountant link' : (curentLang === 'ar' ? 'ربط المحاسب' : 'קישור רו"ח')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Tax No.' : (curentLang === 'ar' ? 'رقم الضريبي' : 'מס עוסק')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Commercial Reg.' : (curentLang === 'ar' ? 'السجل التجاري' : 'מרשם מסחרי')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Created' : (curentLang === 'ar' ? 'تاريخ التسجيل' : 'תאריך הרשמה')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'IRS' : (curentLang === 'ar' ? 'ربط الضرائب' : 'מס הכנסה')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Expiry' : (curentLang === 'ar' ? 'تاريخ الانتهاء' : 'תפוגה')}}</th>
                  <th scope="col" *ngIf="user_type == 200 || user_type == 201">{{ curentLang === 'en' ? 'Docs' : (curentLang === 'ar' ? 'مستندات' : 'מסמכים')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Info' : (curentLang === 'ar' ? 'معلومات' : 'מידע')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Office' : (curentLang === 'ar' ? 'مكتب' : 'משרד')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Report' : (curentLang === 'ar' ? 'تقرير' : 'דוח')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Signature' : (curentLang === 'ar' ? 'التوقيع' : 'חתימה')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Seal' : (curentLang === 'ar' ? 'الختم' : 'חותמת')}}</th>
                  <th *ngIf="user_type == 200 || user_type == 201" scope="col">{{ curentLang === 'en' ? 'Sequence' : (curentLang === 'ar' ? 'التسلسل' : 'רֶצֶף')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'View' : (curentLang === 'ar' ? 'عرض' : 'צפייה')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Edit' : (curentLang === 'ar' ? 'تعديل' : 'תיקון')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Archive' : (curentLang === 'ar' ? 'أرشفة' : 'ארכיון')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Delete' : (curentLang === 'ar' ? 'حذف' : 'מחיקה')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of companyData | paginate: {itemsPerPage: limit, currentPage: currentPage, totalItems: total} | filter:term; let i = index">
                  <td scope="row">{{i+1}}</td>
                  <td>{{ getCompanyDisplayName(item) }}</td>
                  <td>{{ companyTypeLabel(item) }}</td>
                  <td *ngIf="user_type == 100 || user_type == 101">
                    <span *ngIf="shouldShowCompanyLinkBadge(item.company_id)"
                          class="company-link-badge"
                          [ngClass]="getCompanyLinkBadgeClass(item.company_id)">
                      {{ getCompanyLinkBadgeLabel(item.company_id) }}
                    </span>
                    <span *ngIf="!shouldShowCompanyLinkBadge(item.company_id)" class="text-muted small">—</span>
                  </td>
                  <td>{{item.tax_register}}</td>
                  <td>{{item.commercial_register}}</td>
                  <td>{{ item?.createdDate | date: 'dd/MM/yyyy' }}</td>
                  <td>
                    <i class="fa fa-recycle" style="color:#141414;font-size:15px;cursor:pointer;"
                       (click)="handleClick(item.company_id, item.refresh_token_expiration);ConnectWithTaxGovernment()"></i>
                  </td>
                  <td>{{ item.refresh_token_expiration | date:'dd/MM/yyyy' }}</td>
                  <td *ngIf="user_type == 200 || user_type == 201">
                    <i class="fa fa-file-text-o" style="color:black;cursor:pointer;" routerLink="/dashboard/documents/{{item.company_uuid}}"></i>
                  </td>
                  <td>
                    <i class="fa fa-info-circle" style="color:rgb(195,181,22);font-size:15px;cursor:pointer;" (click)="openMoreInfo(item, moreInfoModal)"></i>
                  </td>
                  <td>
                    <i class="fa fa-plus-circle" style="color:#000;font-size:15px;cursor:pointer;"
                       (click)="getCompanyId(item.company_id,item.merchant_id);openXl3(content3)"></i>
                  </td>
                  <td>
                    <i class="fa fa-file-pdf-o" style="color:rgb(46,63,135);font-size:15px;cursor:pointer;"
                       (click)="getCompanyId(item.company_id,item.merchant_id);openXl5(content5, item.company_id)"></i>
                  </td>
                  <td>
                    <button class="btn p-0 border-0" (click)="changeShowSignatureCompany(item?.company_id, item.show_signature)">
                      <i class="fa fa-solid" [class.fa-toggle-on]="item.show_signature" [class.fa-toggle-off]="!item.show_signature"
                         [style.color]="item.show_signature ? '#213FA6' : 'red'"></i>
                    </button>
                  </td>
                  <td>
                    <button class="btn p-0 border-0" (click)="changeShowSealCompany(item?.company_id, item.show_seal)">
                      <i class="fa fa-solid" [class.fa-toggle-on]="item.show_seal" [class.fa-toggle-off]="!item.show_seal"
                         [style.color]="item.show_seal ? '#213FA6' : 'red'"></i>
                    </button>
                  </td>
                  <td *ngIf="user_type == 200 || user_type == 201">
                    <i class="fa fa-random" style="color:rgb(212,85,39);font-size:15px;cursor:pointer;" routerLink="/dashboard/sequanse/{{item.company_id}}"></i>
                  </td>
                  <td>
                    <i class="fa fa-eye" style="color:grey;cursor:pointer;" routerLink="/dashboard/view-company/{{item.company_id}}"></i>
                  </td>
                  <td>
                    <i class="fa fa-edit" style="cursor:pointer;color:green;" routerLink="/dashboard/update-company/{{item.company_uuid}}"></i>
                  </td>
                  <td>
                    <button class="btn p-0 border-0 cc-action-archive-inline" title="{{ curentLang === 'ar' ? 'أرشفة' : (curentLang === 'en' ? 'Archive' : 'ארכיון') }}"
                            (click)="openArchiveConfirm(item?.company_id, archiveConfirm)">
                      <i class="fa fa-archive" style="cursor:pointer;font-size:15px;"></i>
                    </button>
                  </td>
                  <td>
                    <button class="btn p-0 border-0 text-danger" (click)="getId(item?.company_id);openVerticallyCentered(dataDeleted)">
                      <i class="fa fa-trash-o" style="cursor:pointer;"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- ═══════════════════════════════════════ MOBILE & TABLET CARDS (< lg): one card per row -->
          <div class="company-cards-list d-lg-none">
            <div class="company-card"
                 *ngFor="let item of companyData | paginate: {itemsPerPage: limit, currentPage: currentPage, totalItems: total} | filter:term; let i = index">

              <!-- Card Top: name + expiry badge -->
              <div class="cc-header">
                <div class="cc-avatar">
                  <span>{{ getCompanyDisplayNameInitial(item) }}</span>
                </div>
                <div class="cc-title-block">
                  <div class="cc-name">
                    {{ getCompanyDisplayName(item) }}
                  </div>
                  <div class="cc-sub">
                    <span *ngIf="shouldShowCompanyLinkBadge(item.company_id)"
                          class="company-link-badge me-1"
                          [ngClass]="getCompanyLinkBadgeClass(item.company_id)">
                      {{ getCompanyLinkBadgeLabel(item.company_id) }}
                    </span>
                    <i class="fa fa-hashtag me-1"></i>{{item.tax_register}}
                  </div>
                </div>
                <span class="cc-expiry-badge" [class.expired]="item.refresh_token_expiration && (item.refresh_token_expiration | date:'yyyyMMdd') < (today | date:'yyyyMMdd')">
                  {{ item.refresh_token_expiration | date:'dd/MM/yy' }}
                </span>
              </div>

              <!-- Card Body: key info rows -->
              <div class="cc-body">
                <div class="cc-info-row">
                  <span class="cc-label">{{ curentLang === 'en' ? 'Company type' : (curentLang === 'ar' ? 'نوع المصلحة التجارية' : 'סוג חברה') }}</span>
                  <span class="cc-value">{{ companyTypeLabel(item) }}</span>
                </div>
                <div class="cc-info-row">
                  <span class="cc-label">{{ curentLang === 'en' ? 'Commercial Reg.' : (curentLang === 'ar' ? 'السجل التجاري' : 'מרשם מסחרי') }}</span>
                  <span class="cc-value">{{ item.commercial_register }}</span>
                </div>
                <div class="cc-info-row">
                  <span class="cc-label">{{ curentLang === 'en' ? 'Created' : (curentLang === 'ar' ? 'تاريخ التسجيل' : 'תאריך הרשמה') }}</span>
                  <span class="cc-value">{{ item?.createdDate | date: 'dd/MM/yyyy' }}</span>
                </div>
                <div class="cc-info-row">
                  <span class="cc-label">{{ curentLang === 'en' ? 'Signature' : (curentLang === 'ar' ? 'التوقيع' : 'חתימה') }}</span>
                  <button class="btn p-0 border-0 cc-toggle" (click)="changeShowSignatureCompany(item?.company_id, item.show_signature)">
                    <i class="fa fa-solid" [class.fa-toggle-on]="item.show_signature" [class.fa-toggle-off]="!item.show_signature"
                       [style.color]="item.show_signature ? '#213FA6' : '#ccc'" style="font-size:20px;"></i>
                  </button>
                </div>
                <div class="cc-info-row">
                  <span class="cc-label">{{ curentLang === 'en' ? 'Seal' : (curentLang === 'ar' ? 'الختم' : 'חותמת') }}</span>
                  <button class="btn p-0 border-0 cc-toggle" (click)="changeShowSealCompany(item?.company_id, item.show_seal)">
                    <i class="fa fa-solid" [class.fa-toggle-on]="item.show_seal" [class.fa-toggle-off]="!item.show_seal"
                       [style.color]="item.show_seal ? '#213FA6' : '#ccc'" style="font-size:20px;"></i>
                  </button>
                </div>
              </div>

              <!-- Card Actions -->
              <div class="cc-actions">
                <!-- IRS connect -->
                <button class="cc-action-btn" title="{{ curentLang === 'en' ? 'Connect IRS' : (curentLang === 'ar' ? 'ربط الضرائب' : 'מס הכנסה') }}"
                        (click)="handleClick(item.company_id, item.refresh_token_expiration);ConnectWithTaxGovernment()">
                  <i class="fa fa-recycle"></i>
                </button>
                <!-- Docs (admin only) -->
                <button *ngIf="user_type == 200 || user_type == 201" class="cc-action-btn" title="{{ curentLang === 'en' ? 'Documents' : (curentLang === 'ar' ? 'مستندات' : 'מסמכים') }}"
                        [routerLink]="['/dashboard/documents/', item.company_uuid]">
                  <i class="fa fa-file-text-o"></i>
                </button>
                <!-- More info -->
                <button type="button" class="cc-action-btn cc-action-info" title="{{ curentLang === 'en' ? 'More Info' : (curentLang === 'ar' ? 'معلومات' : 'מידע') }}"
                        (click)="openMoreInfo(item, moreInfoModal)">
                  <i class="fa fa-info-circle"></i>
                </button>
                <!-- Add accounting office -->
                <button class="cc-action-btn" title="{{ curentLang === 'en' ? 'Add Office' : (curentLang === 'ar' ? 'مكتب محاسبة' : 'משרד') }}"
                        (click)="getCompanyId(item.company_id,item.merchant_id);openXl3(content3)">
                  <i class="fa fa-plus-circle"></i>
                </button>
                <!-- Sales report -->
                <button class="cc-action-btn cc-action-report" title="{{ curentLang === 'en' ? 'Sales Report' : (curentLang === 'ar' ? 'تقرير' : 'דוח') }}"
                        (click)="getCompanyId(item.company_id,item.merchant_id);openXl5(content5)">
                  <i class="fa fa-file-pdf-o"></i>
                </button>
                <!-- Sequence (admin only) -->
                <button *ngIf="user_type == 200 || user_type == 201" class="cc-action-btn cc-action-seq" title="{{ curentLang === 'en' ? 'Sequence' : (curentLang === 'ar' ? 'التسلسل' : 'רֶצֶף') }}"
                        [routerLink]="['/dashboard/sequanse/', item.company_id]">
                  <i class="fa fa-random"></i>
                </button>
                <!-- View -->
                <button class="cc-action-btn cc-action-view" title="{{ curentLang === 'en' ? 'View' : (curentLang === 'ar' ? 'عرض' : 'צפייה') }}"
                        [routerLink]="['/dashboard/view-company/', item.company_id]">
                  <i class="fa fa-eye"></i>
                </button>
                <!-- Edit -->
                <button class="cc-action-btn cc-action-edit" title="{{ curentLang === 'en' ? 'Edit' : (curentLang === 'ar' ? 'تعديل' : 'תיקון') }}"
                        [routerLink]="['/dashboard/update-company/', item.company_uuid]">
                  <i class="fa fa-edit"></i>
                </button>
                <!-- Archive -->
                <button class="cc-action-btn cc-action-archive-btn" title="{{ curentLang === 'en' ? 'Archive' : (curentLang === 'ar' ? 'أرشفة' : 'ארכיון') }}"
                        (click)="openArchiveConfirm(item?.company_id, archiveConfirm)">
                  <i class="fa fa-archive"></i>
                </button>
                <!-- Delete -->
                <button class="cc-action-btn cc-action-delete" title="{{ curentLang === 'en' ? 'Delete' : (curentLang === 'ar' ? 'حذف' : 'מחיקה') }}"
                        (click)="getId(item?.company_id);openVerticallyCentered(dataDeleted)">
                  <i class="fa fa-trash-o"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Pagination (shared) -->
          <div class="pagination-container">
            <pagination-controls 
              (pageChange)="onPageChange($event)" 
              (totalItems)="total" 
              (currentPage)="currentPage">
            </pagination-controls>
            <input type="number" class="mt-1" [(ngModel)]="customLimit" (change)="onLimitChange()">
          </div>

          <div class="d-flex justify-content-between"> 
            <div></div>
            <div *ngIf="user_type == 100 || user_type == 101">
              <a routerLink="/dashboard/merchant-info">
                <button class="btn btn-danger m-2" *ngIf="!isInsideModal">
                  {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? 'رجوع' : 'חזרה') }}
                  <i class="fa fa-rotate-left mx-1"></i>
                </button>
              </a>
            </div>
            <div *ngIf="user_type == 200 || user_type == 201">
              <a routerLink="/dashboard/companies">
                <button class="btn btn-danger m-2">
                  {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? 'رجوع' : 'חזרה') }}
                  <i class="fa fa-rotate-left mx-1"></i>
                </button>
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

        <!-- ═══════════════ ARCHIVED TAB CONTENT ═══════════════ -->
        <div class="col-sm-12 col-lg-12 col-xl-12" *ngIf="activeTab === 'archived'">

          <!-- Empty state -->
          <div *ngIf="archivedCompanyData.length === 0" class="company-empty-archived">
            <i class="fa fa-archive fa-2x mb-2 d-block" style="opacity:0.25;color:#141414;"></i>
            <p class="mb-0" style="color:#999;font-size:13px;">
              {{ curentLang === 'en' ? 'No archived companies' : (curentLang === 'ar' ? 'لا توجد مصالح تجارية مؤرشفة' : 'אין חברות בארכיון') }}
            </p>
          </div>

          <!-- Archived Desktop Table -->
          <div class="table-responsive d-none d-lg-block" *ngIf="archivedCompanyData.length > 0">
            <table class="table table-light text-center table-hover">
              <thead>
                <tr>
                  <th scope="col">{{ curentLang === 'en' ? '#' : (curentLang === 'ar' ? 'م' : 'מ') }}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Company Name' : (curentLang === 'ar' ? 'أسم المصلحة التجارية' : 'שם החברה')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Company type' : (curentLang === 'ar' ? 'نوع المصلحة التجارية' : 'סוג חברה') }}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Tax No.' : (curentLang === 'ar' ? 'رقم الضريبي' : 'מס עוסק')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Archived On' : (curentLang === 'ar' ? 'تاريخ الأرشفة' : 'תאריך ארכיון')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Documents' : (curentLang === 'ar' ? 'المستندات' : 'מסמכים')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Report' : (curentLang === 'ar' ? 'تقرير' : 'דוח')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Restore' : (curentLang === 'ar' ? 'إعادة تفعيل' : 'שחזור')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of archivedCompanyData; let i = index" class="archived-row">
                  <td>{{ i + 1 }}</td>
                  <td>{{ getCompanyDisplayName(item) }}</td>
                  <td>{{ companyTypeLabel(item) }}</td>
                  <td>{{ item.tax_register }}</td>
                  <td>{{ item.archived_at | date:'dd/MM/yyyy' }}</td>
                  <td>
                    <i class="fa fa-file-text-o" style="color:black;cursor:pointer;"
                       [routerLink]="['/dashboard/documents', item.company_uuid]"
                       [queryParams]="{ archived: '1' }"></i>
                  </td>
                  <td>
                    <i class="fa fa-file-pdf-o" style="color:rgb(46,63,135);font-size:15px;cursor:pointer;"
                       (click)="getCompanyId(item.company_id, item.merchant_id); openXl5(content5, item.company_id)"></i>
                  </td>
                  <td>
                    <button class="btn btn-dark-custom btn-sm" (click)="openRestoreConfirm(item?.company_id, restoreConfirm)">
                      <i class="fa fa-undo me-1"></i>
                      {{ curentLang === 'en' ? 'Restore' : (curentLang === 'ar' ? 'إعادة تفعيل' : 'שחזור') }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Archived Mobile Cards -->
          <div class="company-cards-list d-lg-none" *ngIf="archivedCompanyData.length > 0">
            <div class="company-card archived-card" *ngFor="let item of archivedCompanyData">
              <div class="cc-header">
                <div class="cc-avatar cc-avatar-archived">
                  <span>{{ getCompanyDisplayNameInitial(item) }}</span>
                </div>
                <div class="cc-title-block">
                  <div class="cc-name">{{ getCompanyDisplayName(item) }}</div>
                  <div class="cc-sub"><i class="fa fa-hashtag me-1"></i>{{ item.tax_register }}</div>
                </div>
                <span class="company-archived-badge">
                  {{ curentLang === 'en' ? 'Archived' : (curentLang === 'ar' ? 'مؤرشفة' : 'בארכיון') }}
                </span>
              </div>
              <div class="cc-body">
                <div class="cc-info-row">
                  <span class="cc-label">{{ curentLang === 'en' ? 'Company type' : (curentLang === 'ar' ? 'نوع المصلحة التجارية' : 'סוג חברה') }}</span>
                  <span class="cc-value">{{ companyTypeLabel(item) }}</span>
                </div>
                <div class="cc-info-row">
                  <span class="cc-label">{{ curentLang === 'en' ? 'Archived On' : (curentLang === 'ar' ? 'تاريخ الأرشفة' : 'תאריך ארכיון') }}</span>
                  <span class="cc-value">{{ item.archived_at | date:'dd/MM/yyyy' }}</span>
                </div>
              </div>
              <div class="cc-actions">
                <button class="cc-action-btn cc-action-restore" title="{{ curentLang === 'en' ? 'Restore' : (curentLang === 'ar' ? 'إعادة تفعيل' : 'שחזור') }}"
                        (click)="openRestoreConfirm(item?.company_id, restoreConfirm)">
                  <i class="fa fa-undo"></i>
                </button>
                <button class="cc-action-btn cc-action-report" title="{{ curentLang === 'en' ? 'Report' : (curentLang === 'ar' ? 'تقرير' : 'דוח') }}"
                        (click)="getCompanyId(item.company_id, item.merchant_id); openXl5(content5, item.company_id)">
                  <i class="fa fa-file-pdf-o"></i>
                </button>
                <button class="cc-action-btn" title="{{ curentLang === 'en' ? 'Documents' : (curentLang === 'ar' ? 'مستندات' : 'מסמכים') }}"
                        [routerLink]="['/dashboard/documents', item.company_uuid]"
                        [queryParams]="{ archived: '1' }">
                  <i class="fa fa-file-text-o"></i>
                </button>
              </div>
            </div>
          </div>


        </div>
        <!-- ═══════════════ END ARCHIVED TAB ═══════════════ -->


    </div>
</div>

<!--add company-->

<ng-template #content let-modal>
    <div class="modal-header company-modal-header">
      <div>
        <div class="company-modal-eyebrow">{{ curentLang === 'en' ? 'Company setup' : (curentLang === 'ar' ? 'إعداد المصلحة التجارية' : 'הגדרת חברה') }}</div>
        <h6 class="modal-title company-modal-title">
          {{ curentLang === 'en' ? 'Add Company ' : (curentLang === 'ar' ? ' اضافة مصلحة تجارية ' : '  הוספת חברה')}}
        </h6>
        <p class="company-modal-subtitle">
          {{ curentLang === 'en' ? 'Enter the legal, tax, and address details to create a professional company profile.' : (curentLang === 'ar' ? 'أدخل بيانات المصلحة التجارية الضريبية والعنوان لإنشاء ملف احترافي.' : 'הזן את פרטי החברה, המס והכתובת ליצירת פרופיל מקצועי.') }}
        </p>
      </div>
      <button type="button" class="close btn-close company-modal-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body company-modal-body">
        <div class="container-fluid">
            <div class="edit-profile">
              <div class="row d-flex justify-content-between">
                      <form [formGroup]="addCompany" novalidate [ngClass]="{ 'was-validated': addvalidateCompanyMerchant }" class="company-form-shell add-company-prototype">
                        <section class="company-form-section">
                          <div class="add-co-section-head">
                            <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Basic details' : (curentLang === 'ar' ? 'البيانات الأساسية' : 'פרטים בסיסיים') }}</span>
                            <span class="add-co-req-hint">{{ curentLang === 'en' ? '* Required field' : (curentLang === 'ar' ? '* حقل إلزامي' : '* שדה חובה') }}</span>
                          </div>
                          <div class="row">
                            <div class="mb-3 col-md-6">
                              <label class="form-label">{{ curentLang === 'en' ? 'Company name (Hebrew)' : (curentLang === 'ar' ? 'اسم المصلحة التجارية (عبري)' : 'שם החברה (עברית)') }}<span class="text-danger">*</span></label>
                              <input class="form-control" onlyAlphabets required type="text" formControlName="company_name_he"
                                [placeholder]="curentLang === 'en' ? 'e.g. ABC Ltd.' : (curentLang === 'ar' ? 'مثال: مصلحة تجارية ABC المحدودة' : 'לדוגמה: חברת ABC בע״מ')" />
                              <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'Please enter company name' : (curentLang === 'ar' ? 'الرجاء إدخال اسم المصلحة التجارية' : 'נא להזין את שם החברה') }}</div>
                            </div>
                            <div class="mb-3 col-md-6">
                              <label class="form-label">{{ curentLang === 'en' ? 'Company type' : (curentLang === 'ar' ? 'نوع المصلحة التجارية' : 'סוג חברה') }}<span class="text-danger">*</span></label>
                              <ng-select formControlName="company_type_id" [searchable]="false"
                                [placeholder]="curentLang === 'en' ? 'Choose type…' : (curentLang === 'ar' ? 'اختر النوع…' : 'בחר סוג…')">
                                <ng-option *ngFor="let item of companyTypeData" [value]="item.company_type_id">
                                  {{ curentLang === 'en' ? item.type_name_en : (curentLang === 'ar' ? item.type_name_ar : item.type_name_he) }}
                                </ng-option>
                              </ng-select>
                              <div *ngIf="addCompany.get('company_type_id')?.errors?.required" class="text-danger small mt-1">
                                {{ curentLang === 'en' ? 'Please choose company type' : (curentLang === 'ar' ? 'الرجاء اختيار نوع المصلحة التجارية' : 'אנא בחר סוג חברה') }}
                              </div>
                            </div>
                            <div class="mb-3 col-md-6">
                              <label class="form-label">{{ curentLang === 'en' ? 'Tax ID / company no.' : (curentLang === 'ar' ? 'رقم المشغّل / ح.ف' : 'מספר עוסק / ח.פ') }}<span class="text-danger">*</span></label>
                              <input class="form-control" required type="text" (keypress)="isNumber($event)" maxlength="9" inputmode="numeric"
                                formControlName="tax_register" pattern="[0-9]{9}"
                                [title]="curentLang === 'en' ? '9 digits' : (curentLang === 'ar' ? '9 أرقام' : '9 ספרות')" />
                              <div *ngIf="addCompany.get('tax_register')?.invalid && (addCompany.get('tax_register')?.dirty || addCompany.get('tax_register')?.touched)" class="text-danger small">
                                {{ curentLang === 'en' ? 'Enter exactly 9 digits' : (curentLang === 'ar' ? 'يرجى إدخال 9 أرقام' : 'אנא הזן 9 ספרות') }}
                              </div>
                            </div>
                            <div class="mb-3 col-md-6">
                              <label class="form-label">{{ curentLang === 'en' ? 'Phone' : (curentLang === 'ar' ? 'الهاتف' : 'טלפון') }} <span class="text-muted fw-normal small">{{ curentLang === 'en' ? '(optional)' : (curentLang === 'ar' ? '(اختياري)' : '(אופציונלי)') }}</span></label>
                              <input class="form-control add-co-input-optional" type="tel" formControlName="company_phone" placeholder="05X-XXXXXXX" />
                            </div>
                            <div class="mb-3 col-md-6">
                              <label class="form-label">{{ curentLang === 'en' ? 'Commercial register' : (curentLang === 'ar' ? 'رقم السجل التجاري' : 'מספר רישום מסחרי') }}<span class="text-danger">*</span></label>
                              <input class="form-control" required type="text" formControlName="commercial_register"
                                (keypress)="isNumber($event)" maxlength="9" inputmode="numeric" pattern="[0-9]{1,9}" />
                              <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'Enter commercial register' : (curentLang === 'ar' ? 'أدخل رقم السجل التجاري' : 'נא להזין מספר רישום מסחרי') }}</div>
                            </div>
                          </div>
                        </section>

                        <div class="add-co-divider"></div>

                        <section class="company-form-section">
                          <div class="add-co-section-head">
                            <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Address' : (curentLang === 'ar' ? 'العنوان' : 'כתובת') }}</span>
                          </div>
                          <div class="row">
                            <div class="mb-3 col-md-6">
                              <label class="form-label">{{ curentLang === 'en' ? 'City (Hebrew)' : (curentLang === 'ar' ? 'المدينة (عبري)' : 'עיר (עברית)') }}<span class="text-danger">*</span></label>
                              <input class="form-control" onlyAlphabets required type="text" formControlName="company_address_city" maxlength="100"
                                [placeholder]="curentLang === 'en' ? 'Tel Aviv' : (curentLang === 'ar' ? 'تل أبيب' : 'תל אביב')" />
                              <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'Enter city' : (curentLang === 'ar' ? 'أدخل المدينة' : 'נא להזין עיר') }}</div>
                            </div>
                            <div class="mb-3 col-md-6">
                              <label class="form-label">{{ curentLang === 'en' ? 'Street (Hebrew)' : (curentLang === 'ar' ? 'اسم الشارع (عبري)' : 'שם רחוב (עברית)') }}<span class="text-danger">*</span></label>
                              <input class="form-control" onlyAlphabets required type="text" formControlName="company_address_str" maxlength="100"
                                [placeholder]="curentLang === 'en' ? 'Herzl St.' : (curentLang === 'ar' ? 'شارع هرتسل' : 'רחוב הרצל')" />
                              <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'Enter street' : (curentLang === 'ar' ? 'أدخل الشارع' : 'נא להזין רחוב') }}</div>
                            </div>
                            <div class="mb-3 col-md-6">
                              <label class="form-label">{{ curentLang === 'en' ? 'Building no.' : (curentLang === 'ar' ? 'رقم المبنى' : 'מספר בניין') }}<span class="text-danger">*</span></label>
                              <input class="form-control" onlyAlphabets required type="number" formControlName="company_Building_number" />
                              <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'Enter building number' : (curentLang === 'ar' ? 'أدخل رقم المبنى' : 'נא להזין מספר בניין') }}</div>
                            </div>
                            <div class="mb-3 col-md-6">
                              <label class="form-label">{{ curentLang === 'en' ? 'Postal code' : (curentLang === 'ar' ? 'الرمز البريدي' : 'מיקוד') }} <span class="text-muted fw-normal small">{{ curentLang === 'en' ? '(optional)' : (curentLang === 'ar' ? '(اختياري)' : '(אופציונלי)') }}</span></label>
                              <input class="form-control add-co-input-optional" type="number" formControlName="company_address_zip_code" min="0" placeholder="6100000" />
                            </div>
                          </div>
                        </section>

                        <div class="add-co-divider"></div>

                        <section class="company-form-section">
                          <div class="add-co-section-head">
                            <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Images' : (curentLang === 'ar' ? 'الصور' : 'תמונות') }}</span>
                          </div>
                          <div class="add-co-upload-grid">
                            <div class="add-co-upload-box" [class.has-image]="logoPreviewUrl" (click)="logoInputMerch.click()">
                              <input #logoInputMerch type="file" accept="image/*" class="d-none" (change)="onPendingLogoChange($event)" />
                              <ng-container *ngIf="!logoPreviewUrl">
                                <div class="add-co-upload-icon"><i class="fa fa-image"></i></div>
                                <div class="add-co-upload-label">{{ curentLang === 'en' ? 'Company logo' : (curentLang === 'ar' ? 'شعار المصلحة التجارية' : 'לוגו חברה') }}</div>
                                <div class="add-co-upload-hint">{{ curentLang === 'en' ? 'PNG, JPG up to ~2MB' : (curentLang === 'ar' ? 'PNG، JPG حتى 2MB' : 'PNG, JPG עד 2MB') }}</div>
                              </ng-container>
                              <div class="add-co-upload-preview" *ngIf="logoPreviewUrl">
                                <img [src]="logoPreviewUrl" alt="logo" />
                                <button type="button" class="add-co-remove-file" (click)="$event.stopPropagation(); clearPendingLogo()">{{ curentLang === 'en' ? 'Remove' : (curentLang === 'ar' ? 'حذف الصورة' : 'הסר תמונה') }}</button>
                              </div>
                            </div>
                            <div class="add-co-upload-box" [class.has-image]="sealPreviewUrl" (click)="sealInputMerch.click()">
                              <input #sealInputMerch type="file" accept="image/*" class="d-none" (change)="onPendingSealChange($event)" />
                              <ng-container *ngIf="!sealPreviewUrl">
                                <div class="add-co-upload-icon"><i class="fa fa-pencil"></i></div>
                                <div class="add-co-upload-label">{{ curentLang === 'en' ? 'Seal / signature image' : (curentLang === 'ar' ? 'التوقيع / الختم' : 'חתימה') }}</div>
                                <div class="add-co-upload-hint">{{ curentLang === 'en' ? 'Transparent PNG preferred' : (curentLang === 'ar' ? 'PNG شفاف مفضّل' : 'PNG שקוף מומלץ') }}</div>
                              </ng-container>
                              <div class="add-co-upload-preview" *ngIf="sealPreviewUrl">
                                <img [src]="sealPreviewUrl" alt="seal" />
                                <button type="button" class="add-co-remove-file" (click)="$event.stopPropagation(); clearPendingSeal()">{{ curentLang === 'en' ? 'Remove' : (curentLang === 'ar' ? 'حذف الصورة' : 'הסר תמונה') }}</button>
                              </div>
                            </div>
                          </div>
                        </section>

                        <div class="add-co-divider"></div>

                        <section class="company-form-section">
                          <div class="add-co-section-head">
                            <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Fixed invoice notes' : (curentLang === 'ar' ? 'ملاحظات ثابتة في الفاتورة' : 'הערות קבועות בחשבונית') }}</span>
                          </div>
                          <div class="add-co-notes-grid row">
                            <div class="mb-3 col-md-6">
                              <div class="add-co-notes-col-title"><span class="add-co-dot add-co-dot-dark"></span>{{ curentLang === 'en' ? 'Right column note' : (curentLang === 'ar' ? 'ملاحظات يمين' : 'הערות ימין') }}</div>
                              <textarea class="form-control add-co-input-optional" rows="3" maxlength="200" formControlName="right_note"
                                [placeholder]="curentLang === 'en' ? 'e.g. Payment within 30 days.' : (curentLang === 'ar' ? 'مثال: الدفع خلال 30 يوماً.' : 'לדוגמה: תשלום בתוך 30 יום.')"
                                [class.is-invalid]="addCompany.get('right_note')?.invalid && addCompany.get('right_note')?.touched"></textarea>
                              <small class="text-muted d-block mt-1">{{ curentLang === 'en' ? 'Maximum 200 characters.' : (curentLang === 'ar' ? 'حد أقصى 200 حرفاً.' : 'עד 200 תווים.') }}</small>
                            </div>
                            <div class="mb-3 col-md-6">
                              <div class="add-co-notes-col-title"><span class="add-co-dot add-co-dot-muted"></span>{{ curentLang === 'en' ? 'Left column note' : (curentLang === 'ar' ? 'ملاحظات يسار' : 'הערות שמאל') }}</div>
                              <textarea class="form-control add-co-input-optional" rows="3" maxlength="200" formControlName="left_note"
                                [placeholder]="curentLang === 'en' ? 'e.g. IBAN: IL00-0000-0000' : (curentLang === 'ar' ? 'مثال: IBAN: IL00-0000-0000' : 'לדוגמה: IBAN: IL00-0000-0000')"
                                [class.is-invalid]="addCompany.get('left_note')?.invalid && addCompany.get('left_note')?.touched"></textarea>
                              <small class="text-muted d-block mt-1">{{ curentLang === 'en' ? 'Maximum 200 characters.' : (curentLang === 'ar' ? 'حد أقصى 200 حرفاً.' : 'עד 200 תווים.') }}</small>
                            </div>
                          </div>
                          <div class="add-co-invoice-preview-strip">
                            <div class="add-co-preview-side" [class.empty]="!(addCompany.get('right_note')?.value || '').toString().trim()">
                              {{ (addCompany.get('right_note')?.value || '').toString().trim() || (curentLang === 'en' ? 'Right note…' : (curentLang === 'ar' ? 'ملاحظات يمين...' : 'הערות ימין...')) }}
                            </div>
                            <div class="add-co-preview-center">{{ curentLang === 'en' ? '— Invoice preview —' : (curentLang === 'ar' ? '— معاينة الفاتورة —' : '— תצוגת חשבונית —') }}</div>
                            <div class="add-co-preview-side" [class.empty]="!(addCompany.get('left_note')?.value || '').toString().trim()">
                              {{ (addCompany.get('left_note')?.value || '').toString().trim() || (curentLang === 'en' ? 'Left note…' : (curentLang === 'ar' ? 'ملاحظات يسار...' : 'הערות שמאל...')) }}
                            </div>
                          </div>
                        </section>

                        <div class="add-co-divider"></div>

                        <section class="company-form-section">
                          <div class="add-co-section-head">
                            <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Translations' : (curentLang === 'ar' ? 'الترجمات' : 'תרגומים') }}</span>
                          </div>

                          <div *ngIf="translationAddon.ar" class="add-co-lang-block">
                            <div class="add-co-lang-block-head">
                              <span><span class="me-1">🇸🇦</span>عربي</span>
                              <button type="button" class="add-co-btn-remove-lang" (click)="removeTranslationLang('ar')">{{ curentLang === 'en' ? 'Remove' : (curentLang === 'ar' ? 'حذف' : 'הסר') }} ✕</button>
                            </div>
                            <div class="row">
                              <div class="mb-3 col-md-6">
                                <label class="form-label">{{ curentLang === 'en' ? 'Company name (Arabic)' : (curentLang === 'ar' ? 'اسم المصلحة التجارية (عربي)' : 'שם החברה (ערבית)') }}</label>
                                <input class="form-control" type="text" formControlName="company_name_ar" placeholder="مثال: مصلحة تجارية ABC المحدودة" />
                              </div>
                              <div class="mb-3 col-md-6">
                                <label class="form-label">{{ curentLang === 'en' ? 'City (Arabic)' : (curentLang === 'ar' ? 'المدينة (عربي)' : 'עיר (ערבית)') }}</label>
                                <input class="form-control" type="text" formControlName="company_address_city_ar" maxlength="100" />
                              </div>
                              <div class="mb-3 col-12">
                                <label class="form-label">{{ curentLang === 'en' ? 'Street (Arabic)' : (curentLang === 'ar' ? 'اسم الشارع (عربي)' : 'רחוב (ערבית)') }}</label>
                                <input class="form-control" type="text" formControlName="company_address_str_ar" maxlength="100" />
                              </div>
                            </div>
                          </div>

                          <div *ngIf="translationAddon.en" class="add-co-lang-block" dir="ltr">
                            <div class="add-co-lang-block-head">
                              <span><span class="me-1">🇬🇧</span>English</span>
                              <button type="button" class="add-co-btn-remove-lang" (click)="removeTranslationLang('en')">{{ curentLang === 'en' ? 'Remove' : (curentLang === 'ar' ? 'حذف' : 'הסר') }} ✕</button>
                            </div>
                            <div class="row">
                              <div class="mb-3 col-md-6">
                                <label class="form-label">Company name (English)</label>
                                <input class="form-control" type="text" formControlName="company_name_en" placeholder="e.g. ABC Ltd." />
                              </div>
                              <div class="mb-3 col-md-6">
                                <label class="form-label">City (English)</label>
                                <input class="form-control" type="text" formControlName="company_address_city_en" maxlength="100" />
                              </div>
                              <div class="mb-3 col-12">
                                <label class="form-label">Street (English)</label>
                                <input class="form-control" type="text" formControlName="company_address_str_en" maxlength="100" />
                              </div>
                            </div>
                          </div>

                          <div class="add-co-add-lang-wrap" *ngIf="showAddTranslationButton">
                            <div class="add-co-lang-picker">
                              <button type="button" class="add-co-btn-add-lang" (click)="toggleTranslationPicker()">
                                <i class="fa fa-plus"></i> {{ curentLang === 'en' ? 'Add language' : (curentLang === 'ar' ? 'أضف لغة' : 'הוסף שפה') }}
                              </button>
                              <div class="add-co-lang-dropdown" *ngIf="translationPickerOpen">
                                <button type="button" class="add-co-lang-option" *ngIf="!translationAddon.ar" (click)="addTranslationLang('ar')"><span class="me-1">🇸🇦</span> عربي</button>
                                <button type="button" class="add-co-lang-option" *ngIf="!translationAddon.en" (click)="addTranslationLang('en')"><span class="me-1">🇬🇧</span> English</button>
                              </div>
                            </div>
                          </div>
                        </section>

                        <div class="company-form-footer">
                          <button type="button" class="btn company-btn-primary" (click)="addedData()">
                            {{ curentLang === 'en' ? 'Confirm' : (curentLang === 'ar' ? 'تأكيد' : 'אישור') }}
                            <i class="fa fa-check-circle mx-1"></i>
                          </button>
                          <button type="button" class="btn company-btn-secondary" (click)="modal.close('Close click')">
                            {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? 'رجوع' : 'חזרה') }} ↩
                          </button>
                        </div>
                      </form>
                
               
               
            
              
            </div>
            
          </div>
        
        </div>
    </div>
   
</ng-template>




<!--add company by admin-->

<ng-template #contentAdmin let-modal>
  <div class="modal-header company-modal-header">
      <div>
        <div class="company-modal-eyebrow">{{ curentLang === 'en' ? 'Company setup' : (curentLang === 'ar' ? 'إعداد المصلحة التجارية' : 'הגדרת חברה') }}</div>
        <h6 class="modal-title company-modal-title">
          {{ curentLang === 'en' ? 'Add Company ' : (curentLang === 'ar' ? ' اضافة مصلحة تجارية ' : '  הוספת חברה')}}
        </h6>
        <p class="company-modal-subtitle">
          {{ curentLang === 'en' ? 'Create a company under a merchant with polished profile details and correct tax data.' : (curentLang === 'ar' ? 'أنشئ مصلحة تجارية مرتبطة بتاجر مع بيانات منظمة ودقيقة.' : 'צור חברה תחת סוחר עם פרטים מסודרים ונתוני מס מדויקים.') }}
        </p>
      </div>
      <button type="button" class="close btn-close company-modal-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body company-modal-body">
      <div class="container-fluid ">
          <div class="edit-profile">
            <div class="row d-flex justify-content-between">
                    <form [formGroup]="addCompanyByAdmin" novalidate [ngClass]="{ 'was-validated': validate }" class="company-form-shell add-company-prototype">
                      <section class="company-form-section">
                        <div class="add-co-section-head">
                          <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Basic details' : (curentLang === 'ar' ? 'البيانات الأساسية' : 'פרטים בסיסיים') }}</span>
                          <span class="add-co-req-hint">{{ curentLang === 'en' ? '* Required field' : (curentLang === 'ar' ? '* حقل إلزامي' : '* שדה חובה') }}</span>
                        </div>
                        <div class="row">
                          <div class="mb-3 col-md-6">
                            <label class="form-label">{{ curentLang === 'en' ? 'Company name (Hebrew)' : (curentLang === 'ar' ? 'اسم المصلحة التجارية (عبري)' : 'שם החברה (עברית)') }}<span class="text-danger">*</span></label>
                            <input class="form-control" onlyAlphabets required type="text" formControlName="company_name_he"
                              [placeholder]="curentLang === 'en' ? 'e.g. ABC Ltd.' : (curentLang === 'ar' ? 'مثال: مصلحة تجارية ABC المحدودة' : 'לדוגמה: חברת ABC בע״מ')" />
                            <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'Please enter company name' : (curentLang === 'ar' ? 'الرجاء إدخال اسم المصلحة التجارية' : 'נא להזין את שם החברה') }}</div>
                          </div>
                          <div class="mb-3 col-md-6">
                            <label class="form-label">{{ curentLang === 'en' ? 'Company type' : (curentLang === 'ar' ? 'نوع المصلحة التجارية' : 'סוג חברה') }}<span class="text-danger">*</span></label>
                            <ng-select formControlName="company_type_id" [searchable]="false"
                              [placeholder]="curentLang === 'en' ? 'Choose type…' : (curentLang === 'ar' ? 'اختر النوع…' : 'בחר סוג…')">
                              <ng-option *ngFor="let item of companyTypeData" [value]="item.company_type_id">
                                {{ curentLang === 'en' ? item.type_name_en : (curentLang === 'ar' ? item.type_name_ar : item.type_name_he) }}
                              </ng-option>
                            </ng-select>
                            <div *ngIf="addCompanyByAdmin.get('company_type_id')?.errors?.required" class="text-danger small mt-1">
                              {{ curentLang === 'en' ? 'Please choose company type' : (curentLang === 'ar' ? 'الرجاء اختيار نوع المصلحة التجارية' : 'אנא בחר סוג חברה') }}
                            </div>
                          </div>
                          <div class="mb-3 col-md-6">
                            <label class="form-label">{{ curentLang === 'en' ? 'Tax ID / company no.' : (curentLang === 'ar' ? 'رقم المشغّل / ح.ف' : 'מספר עוסק / ח.פ') }}<span class="text-danger">*</span></label>
                            <input class="form-control" required type="text" (keypress)="isNumber($event)" maxlength="9" inputmode="numeric"
                              formControlName="tax_register" pattern="[0-9]{9}" />
                            <div *ngIf="addCompanyByAdmin.get('tax_register')?.invalid && (addCompanyByAdmin.get('tax_register')?.dirty || addCompanyByAdmin.get('tax_register')?.touched)" class="text-danger small">
                              {{ curentLang === 'en' ? 'Enter exactly 9 digits' : (curentLang === 'ar' ? 'يرجى إدخال 9 أرقام' : 'אנא הזן 9 ספרות') }}
                            </div>
                          </div>
                          <div class="mb-3 col-md-6">
                            <label class="form-label">{{ curentLang === 'en' ? 'Phone' : (curentLang === 'ar' ? 'الهاتف' : 'טלפון') }} <span class="text-muted fw-normal small">{{ curentLang === 'en' ? '(optional)' : (curentLang === 'ar' ? '(اختياري)' : '(אופציונלי)') }}</span></label>
                            <input class="form-control add-co-input-optional" type="tel" formControlName="company_phone" placeholder="05X-XXXXXXX" />
                          </div>
                          <div class="mb-3 col-md-6">
                            <label class="form-label">{{ curentLang === 'en' ? 'Merchant' : (curentLang === 'ar' ? 'التاجر' : 'סוחר') }}<span class="text-danger">*</span></label>
                            <ng-select formControlName="merchant_id" (change)="filterMerchant($event)"
                              [placeholder]="curentLang === 'en' ? 'Select…' : (curentLang === 'ar' ? 'اختر…' : 'בחר…')">
                              <ng-option *ngFor="let item of merchantInfoData" [value]="item.merchant_id">
                                {{ curentLang === 'en' ? item.merchant_name_en : (curentLang === 'ar' ? item.merchant_name_ar : item.merchant_name_he) }}
                              </ng-option>
                            </ng-select>
                            <div *ngIf="addCompanyByAdmin.get('merchant_id')?.errors?.required" class="text-danger small mt-1">
                              {{ curentLang === 'en' ? 'Please select merchant' : (curentLang === 'ar' ? 'اختر التاجر' : 'אנא בחר סוחר') }}
                            </div>
                          </div>
                          <div class="mb-3 col-md-6">
                            <label class="form-label">{{ curentLang === 'en' ? 'Commercial register' : (curentLang === 'ar' ? 'رقم السجل التجاري' : 'מספר רישום מסחרי') }}<span class="text-danger">*</span></label>
                            <input class="form-control" required type="text" formControlName="commercial_register"
                              (keypress)="isNumber($event)" maxlength="9" inputmode="numeric" pattern="[0-9]{1,9}" />
                          </div>
                        </div>
                      </section>

                      <div class="add-co-divider"></div>

                      <section class="company-form-section">
                        <div class="add-co-section-head">
                          <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Address' : (curentLang === 'ar' ? 'العنوان' : 'כתובת') }}</span>
                        </div>
                        <div class="row">
                          <div class="mb-3 col-md-6">
                            <label class="form-label">{{ curentLang === 'en' ? 'City (Hebrew)' : (curentLang === 'ar' ? 'المدينة (عبري)' : 'עיר (עברית)') }}<span class="text-danger">*</span></label>
                            <input class="form-control" onlyAlphabets required type="text" formControlName="company_address_city" maxlength="100"
                              [placeholder]="curentLang === 'en' ? 'Tel Aviv' : (curentLang === 'ar' ? 'تل أبيب' : 'תל אביב')" />
                            <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'Enter city' : (curentLang === 'ar' ? 'أدخل المدينة' : 'נא להזין עיר') }}</div>
                          </div>
                          <div class="mb-3 col-md-6">
                            <label class="form-label">{{ curentLang === 'en' ? 'Street (Hebrew)' : (curentLang === 'ar' ? 'اسم الشارع (عبري)' : 'שם רחוב (עברית)') }}<span class="text-danger">*</span></label>
                            <input class="form-control" onlyAlphabets required type="text" formControlName="company_address_str" maxlength="100"
                              [placeholder]="curentLang === 'en' ? 'Herzl St.' : (curentLang === 'ar' ? 'شارع هرتسل' : 'רחוב הרצל')" />
                            <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'Enter street' : (curentLang === 'ar' ? 'أدخل الشارع' : 'נא להזין רחוב') }}</div>
                          </div>
                          <div class="mb-3 col-md-6">
                            <label class="form-label">{{ curentLang === 'en' ? 'Building no.' : (curentLang === 'ar' ? 'رقم المبنى' : 'מספר בניין') }}<span class="text-danger">*</span></label>
                            <input class="form-control" onlyAlphabets required type="number" formControlName="company_Building_number" />
                            <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'Enter building number' : (curentLang === 'ar' ? 'أدخل رقم المبنى' : 'נא להזין מספר בניין') }}</div>
                          </div>
                          <div class="mb-3 col-md-6">
                            <label class="form-label">{{ curentLang === 'en' ? 'Postal code' : (curentLang === 'ar' ? 'الرمز البريدي' : 'מיקוד') }} <span class="text-muted fw-normal small">{{ curentLang === 'en' ? '(optional)' : (curentLang === 'ar' ? '(اختياري)' : '(אופציונלי)') }}</span></label>
                            <input class="form-control add-co-input-optional" type="number" formControlName="company_address_zip_code" min="0" placeholder="6100000" />
                          </div>
                        </div>
                      </section>

                      <div class="add-co-divider"></div>

                      <section class="company-form-section">
                        <div class="add-co-section-head">
                          <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Images' : (curentLang === 'ar' ? 'الصور' : 'תמונות') }}</span>
                        </div>
                        <div class="add-co-upload-grid">
                          <div class="add-co-upload-box" [class.has-image]="logoPreviewUrl" (click)="logoInputAdmin.click()">
                            <input #logoInputAdmin type="file" accept="image/*" class="d-none" (change)="onPendingLogoChange($event)" />
                            <ng-container *ngIf="!logoPreviewUrl">
                              <div class="add-co-upload-icon"><i class="fa fa-image"></i></div>
                              <div class="add-co-upload-label">{{ curentLang === 'en' ? 'Company logo' : (curentLang === 'ar' ? 'شعار المصلحة التجارية' : 'לוגו חברה') }}</div>
                              <div class="add-co-upload-hint">{{ curentLang === 'en' ? 'PNG, JPG up to ~2MB' : (curentLang === 'ar' ? 'PNG، JPG حتى 2MB' : 'PNG, JPG עד 2MB') }}</div>
                            </ng-container>
                            <div class="add-co-upload-preview" *ngIf="logoPreviewUrl">
                              <img [src]="logoPreviewUrl" alt="logo" />
                              <button type="button" class="add-co-remove-file" (click)="$event.stopPropagation(); clearPendingLogo()">{{ curentLang === 'en' ? 'Remove' : (curentLang === 'ar' ? 'حذف الصورة' : 'הסר תמונה') }}</button>
                            </div>
                          </div>
                          <div class="add-co-upload-box" [class.has-image]="sealPreviewUrl" (click)="sealInputAdmin.click()">
                            <input #sealInputAdmin type="file" accept="image/*" class="d-none" (change)="onPendingSealChange($event)" />
                            <ng-container *ngIf="!sealPreviewUrl">
                              <div class="add-co-upload-icon"><i class="fa fa-pencil"></i></div>
                              <div class="add-co-upload-label">{{ curentLang === 'en' ? 'Seal / signature image' : (curentLang === 'ar' ? 'التوقيع / الختم' : 'חתימה') }}</div>
                              <div class="add-co-upload-hint">{{ curentLang === 'en' ? 'Transparent PNG preferred' : (curentLang === 'ar' ? 'PNG شفاف مفضّل' : 'PNG שקוף מומלץ') }}</div>
                            </ng-container>
                            <div class="add-co-upload-preview" *ngIf="sealPreviewUrl">
                              <img [src]="sealPreviewUrl" alt="seal" />
                              <button type="button" class="add-co-remove-file" (click)="$event.stopPropagation(); clearPendingSeal()">{{ curentLang === 'en' ? 'Remove' : (curentLang === 'ar' ? 'حذف الصورة' : 'הסר תמונה') }}</button>
                            </div>
                          </div>
                        </div>
                      </section>

                      <div class="add-co-divider"></div>

                      <section class="company-form-section">
                        <div class="add-co-section-head">
                          <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Fixed invoice notes' : (curentLang === 'ar' ? 'ملاحظات ثابتة في الفاتورة' : 'הערות קבועות בחשבונית') }}</span>
                        </div>
                        <div class="add-co-notes-grid row">
                          <div class="mb-3 col-md-6">
                            <div class="add-co-notes-col-title"><span class="add-co-dot add-co-dot-dark"></span>{{ curentLang === 'en' ? 'Right column note' : (curentLang === 'ar' ? 'ملاحظات يمين' : 'הערות ימין') }}</div>
                            <textarea class="form-control add-co-input-optional" rows="3" maxlength="200" formControlName="right_note"
                              [placeholder]="curentLang === 'en' ? 'e.g. Payment within 30 days.' : (curentLang === 'ar' ? 'مثال: الدفع خلال 30 يوماً.' : 'לדוגמה: תשלום בתוך 30 יום.')"
                              [class.is-invalid]="addCompanyByAdmin.get('right_note')?.invalid && addCompanyByAdmin.get('right_note')?.touched"></textarea>
                            <small class="text-muted d-block mt-1">{{ curentLang === 'en' ? 'Maximum 200 characters.' : (curentLang === 'ar' ? 'حد أقصى 200 حرفاً.' : 'עד 200 תווים.') }}</small>
                          </div>
                          <div class="mb-3 col-md-6">
                            <div class="add-co-notes-col-title"><span class="add-co-dot add-co-dot-muted"></span>{{ curentLang === 'en' ? 'Left column note' : (curentLang === 'ar' ? 'ملاحظات يسار' : 'הערות שמאל') }}</div>
                            <textarea class="form-control add-co-input-optional" rows="3" maxlength="200" formControlName="left_note"
                              [placeholder]="curentLang === 'en' ? 'e.g. IBAN: IL00-0000-0000' : (curentLang === 'ar' ? 'مثال: IBAN: IL00-0000-0000' : 'לדוגמה: IBAN: IL00-0000-0000')"
                              [class.is-invalid]="addCompanyByAdmin.get('left_note')?.invalid && addCompanyByAdmin.get('left_note')?.touched"></textarea>
                            <small class="text-muted d-block mt-1">{{ curentLang === 'en' ? 'Maximum 200 characters.' : (curentLang === 'ar' ? 'حد أقصى 200 حرفاً.' : 'עד 200 תווים.') }}</small>
                          </div>
                        </div>
                        <div class="add-co-invoice-preview-strip">
                          <div class="add-co-preview-side" [class.empty]="!(addCompanyByAdmin.get('right_note')?.value || '').toString().trim()">
                            {{ (addCompanyByAdmin.get('right_note')?.value || '').toString().trim() || (curentLang === 'en' ? 'Right note…' : (curentLang === 'ar' ? 'ملاحظات يمين...' : 'הערות ימין...')) }}
                          </div>
                          <div class="add-co-preview-center">{{ curentLang === 'en' ? '— Invoice preview —' : (curentLang === 'ar' ? '— معاينة الفاتورة —' : '— תצוגת חשבונית —') }}</div>
                          <div class="add-co-preview-side" [class.empty]="!(addCompanyByAdmin.get('left_note')?.value || '').toString().trim()">
                            {{ (addCompanyByAdmin.get('left_note')?.value || '').toString().trim() || (curentLang === 'en' ? 'Left note…' : (curentLang === 'ar' ? 'ملاحظات يسار...' : 'הערות שמאל...')) }}
                          </div>
                        </div>
                      </section>

                      <div class="add-co-divider"></div>

                      <section class="company-form-section">
                        <div class="add-co-section-head">
                          <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Translations' : (curentLang === 'ar' ? 'الترجمات' : 'תרגומים') }}</span>
                        </div>

                        <div *ngIf="translationAddon.ar" class="add-co-lang-block">
                          <div class="add-co-lang-block-head">
                            <span><span class="me-1">🇸🇦</span>عربي</span>
                            <button type="button" class="add-co-btn-remove-lang" (click)="removeTranslationLang('ar')">{{ curentLang === 'en' ? 'Remove' : (curentLang === 'ar' ? 'حذف' : 'הסר') }} ✕</button>
                          </div>
                          <div class="row">
                            <div class="mb-3 col-md-6">
                              <label class="form-label">{{ curentLang === 'en' ? 'Company name (Arabic)' : (curentLang === 'ar' ? 'اسم المصلحة التجارية (عربي)' : 'שם החברה (ערבית)') }}</label>
                              <input class="form-control" type="text" formControlName="company_name_ar" />
                            </div>
                            <div class="mb-3 col-md-6">
                              <label class="form-label">{{ curentLang === 'en' ? 'City (Arabic)' : (curentLang === 'ar' ? 'المدينة (عربي)' : 'עיר (ערבית)') }}</label>
                              <input class="form-control" type="text" formControlName="company_address_city_ar" maxlength="100" />
                            </div>
                            <div class="mb-3 col-12">
                              <label class="form-label">{{ curentLang === 'en' ? 'Street (Arabic)' : (curentLang === 'ar' ? 'اسم الشارع (عربي)' : 'רחוב (ערבית)') }}</label>
                              <input class="form-control" type="text" formControlName="company_address_str_ar" maxlength="100" />
                            </div>
                          </div>
                        </div>

                        <div *ngIf="translationAddon.en" class="add-co-lang-block" dir="ltr">
                          <div class="add-co-lang-block-head">
                            <span><span class="me-1">🇬🇧</span>English</span>
                            <button type="button" class="add-co-btn-remove-lang" (click)="removeTranslationLang('en')">{{ curentLang === 'en' ? 'Remove' : (curentLang === 'ar' ? 'حذف' : 'הסר') }} ✕</button>
                          </div>
                          <div class="row">
                            <div class="mb-3 col-md-6">
                              <label class="form-label">Company name (English)</label>
                              <input class="form-control" type="text" formControlName="company_name_en" />
                            </div>
                            <div class="mb-3 col-md-6">
                              <label class="form-label">City (English)</label>
                              <input class="form-control" type="text" formControlName="company_address_city_en" maxlength="100" />
                            </div>
                            <div class="mb-3 col-12">
                              <label class="form-label">Street (English)</label>
                              <input class="form-control" type="text" formControlName="company_address_str_en" maxlength="100" />
                            </div>
                          </div>
                        </div>

                        <div class="add-co-add-lang-wrap" *ngIf="showAddTranslationButton">
                          <div class="add-co-lang-picker">
                            <button type="button" class="add-co-btn-add-lang" (click)="toggleTranslationPicker()">
                              <i class="fa fa-plus"></i> {{ curentLang === 'en' ? 'Add language' : (curentLang === 'ar' ? 'أضف لغة' : 'הוסף שפה') }}
                            </button>
                            <div class="add-co-lang-dropdown" *ngIf="translationPickerOpen">
                              <button type="button" class="add-co-lang-option" *ngIf="!translationAddon.ar" (click)="addTranslationLang('ar')"><span class="me-1">🇸🇦</span> عربي</button>
                              <button type="button" class="add-co-lang-option" *ngIf="!translationAddon.en" (click)="addTranslationLang('en')"><span class="me-1">🇬🇧</span> English</button>
                            </div>
                          </div>
                        </div>
                      </section>

                      <div class="company-form-footer">
                        <button type="button" class="btn company-btn-primary" (click)="addedDataByAadmin()" [disabled]="addCompanyByAdmin.invalid">
                          {{ curentLang === 'en' ? 'Confirm' : (curentLang === 'ar' ? 'تأكيد' : 'אישור') }}
                          <i class="fa fa-check-circle mx-1"></i>
                        </button>
                        <button type="button" class="btn company-btn-secondary" (click)="modal.close('Close click')">
                          {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? 'رجوع' : 'חזרה') }} ↩
                        </button>
                      </div>
                    </form>
            
          </div>
          
        </div>
      
      </div>
  </div>
 
</ng-template>





<!--add Permissions-->

<ng-template #content3 let-modal>
  <div class="modal-header d-flex justify-content-between">
      <h6 class="modal-title"style="color: grey;">
          {{ curentLang === 'en' ? 'Adding an accounting office to the company' : (curentLang === 'ar' ? 'اضافة مكتبة محاسبة للمصلحة تجارية' : 'הוספת ספריית הנהלת חשבונות לחברה')}}
      </h6>
      <button type="button" class="close btn-close" style="color: grey;" aria-label="Close" (click)="modal.dismiss('Cross click')">

    </button>
  </div>
  <div class="modal-body">
      <div class="container-fluid ">
          <div class="edit-profile">
            <div class="row d-flex justify-content-between">
              <form [formGroup]="addPermissionForm">
                <div class="row">
                  <div class="mb-3 col-xl-12 col-md-12">
                    <label class="form-label" style="color: grey;">
                      {{ curentLang === 'en' ? 'Office Accountant Name' : (curentLang === 'ar' ? 'اسم مكتب المحاسبة' : 'שם משרד רואי החשבון') }}
                    </label>
                    <ng-select formControlName="companyUser" [(ngModel)]="selectedOffice" (change)="filterSelected(selectedOffice)" [multiple]="true"
                    style="cursor: pointer;" placeholder="{{ curentLang === 'en' ? 'Select' : (curentLang === 'ar' ? 'اختر' : 'בחירה') }}">
                      <ng-option *ngFor="let item of activeAccountantOfficeData; let i = index" [value]="item">
                        <span>{{item?.office_name}}  </span>
                        <span style="color: transparent;">{{item.office_phone}}</span>
                      </ng-option>
                    </ng-select>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-sm m-auto mt-2" style="background-color: #141414; color: #fff;"
                  [disabled]="addPermissionForm.invalid" (click)="addedPermission()">
                    {{ curentLang === 'en' ? 'Confirm' : (curentLang === 'ar' ? 'تاكيد' : 'אישור') }}
                    <i class="fa fa-check-circle mx-1" style="color: #fff;"></i>
                  </button>
                  <button type="button" class="btn btn-sm m-auto mt-2 btn-danger" (click)="modal.close('Close click')">
                    {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? 'رجوع' : 'חזרה') }}
                    <i class="fa fa-rotate-left mx-1"></i>
                  </button>
                </div>
              </form>
              
                 
              
          </div>
          
        </div>
      
      </div>
  </div>
 
</ng-template>





<ng-template #content4 let-modal>
  <div class="modal-header">
    <h4 class="modal-title"></h4>
    <button type="button" class="close btn-close"  style="color: grey;"  aria-label="Close" (click)="modal.dismiss('Cross click')">
       
    </button>
  </div>
  <div class="modal-body">
    <p class="text-center text-danger">
      <i class="fa fa-trash text-danger"></i>
      {{curentLang === 'en' ? ' Are you sure you want to contact the IRS ?' : (curentLang === 'ar' ? ' هل تريد بالتأكيد الربط مع مصلحة الضرائب ؟ ' : 'האם אתה בטוח שאתה רוצה ליצור קשר עם מס הכנסה?')}}
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm m-auto mt-2" style="background-color: #141414; color: #fff;"
    (click)="ConnectWithTaxGovernment()">
      {{ curentLang === 'en' ? 'Confirm' : (curentLang === 'ar' ? 'تاكيد' : 'אישור') }}
      <i class="fa fa-check-circle mx-1" style="color: #fff;"></i>
    </button>
    <button type="button" class="btn btn-sm m-auto mt-2 btn-danger" (click)="modal.close('Close click')">
      {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? 'رجوع' : 'חזרה') }}
      <i class="fa fa-rotate-left mx-1"></i>
    </button>
  </div>
</ng-template>



   <!--Delete company-->

   <ng-template #dataDeleted let-modal>
    <div class="modal-header">
        <h4 class="modal-title"></h4>
        <button type="button" class="close btn-close"  style="color: grey;"  aria-label="Close" (click)="modal.dismiss('Cross click')">
             
        </button>
    </div>
    <div class="modal-body">
        <p class="text-center text-danger"> <i class="fa fa-trash text-danger"></i>
          {{curentLang === 'en' ? 'Are you sure you want to delete it?' : (curentLang === 'ar' ? '  هل تريد بالتأكيد حذفه؟ ' : ' هل تريد بالتأكيد حذفه؟') }}
        </p>
    </div>
    <div class="modal-footer">

      <button type="button" 
       class="btn btn-sm m-auto mt-2" 
      style="background-color: #141414; color: #fff;"
       (click)="deleteCompanyByCompanyId()"
       > 
        {{ curentLang === 'en' ? 'Confirm' : (curentLang === 'ar' ? '  تاكيد ' : '  אישור  ') }}
        <i class="fa fa-check-circle mx-1" style="color: #fff;"></i>
    </button>

        <button type="button" class="btn btn-sm m-auto mt-2 btn-danger" (click)="modal.close('Close click')">
            {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? '  رجوع ' : '  חזרה  ') }}
            <i class="fa fa-rotate-left mx-1"></i>
        </button>

      

    </div>
</ng-template>
 



<!--export sales report-->

<ng-template #content5 let-modal>
  <div class="modal-header d-flex justify-content-between">
      <h6 class="modal-title"style="color: grey;">
          {{ curentLang === 'en' ? 'Issuing a sales report' : (curentLang === 'ar' ? ' اصدار تقرير مبيعات ' : 'הוצאת דו"ח מכירה')}}
      </h6>
      <button type="button" class="close btn-close" style="color: grey;" aria-label="Close" (click)="modal.dismiss('Cross click')">

    </button>
  </div>
  <div class="modal-body">
      <div class="container-fluid ">
          <div class="edit-profile">
            <div class="row d-flex justify-content-between">
              <form [formGroup]="reportsForm"   >

                <!-- Company selector — shows all companies including archived -->
                <div class="row mb-3">
                  <div class="col-12">
                    <h6 class="form-label px-1" style="color:grey;">
                      {{ curentLang === 'en' ? 'Company' : (curentLang === 'ar' ? 'المصلحة التجارية' : 'חברה') }}
                      <span class="text-danger">*</span>
                    </h6>
                    <ng-select
                      [items]="allCompaniesForReport"
                      [searchable]="true"
                      [clearable]="true"
                      bindValue="company_id"
                      [placeholder]="curentLang === 'en' ? 'Select company…' : (curentLang === 'ar' ? 'اختر المصلحة التجارية…' : 'בחר חברה…')"
                      [(ngModel)]="CompanyId"
                      [ngModelOptions]="{standalone: true}"
                      (change)="onReportCompanyChange($event)">
                      <ng-template ng-label-tmp let-item="item">
                        <span>{{ getCompanyDisplayName(item) }}</span>
                        <span *ngIf="item?.company_status === 'ARCHIVED'" class="company-archived-badge ms-2" style="font-size:10px;">
                          {{ curentLang === 'en' ? 'Archived' : (curentLang === 'ar' ? 'مؤرشفة' : 'בארכיון') }}
                        </span>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span>{{ getCompanyDisplayName(item) }}</span>
                        <span *ngIf="item?.company_status === 'ARCHIVED'" class="company-archived-badge ms-2" style="font-size:10px;">
                          {{ curentLang === 'en' ? 'Archived' : (curentLang === 'ar' ? 'مؤرشفة' : 'בארכיון') }}
                        </span>
                      </ng-template>
                    </ng-select>
                    <div *ngIf="!CompanyId" class="text-muted small mt-1">
                      <i class="fa fa-info-circle me-1"></i>
                      {{ curentLang === 'en' ? 'You can also select an archived company to view its historical report.' : (curentLang === 'ar' ? 'يمكنك أيضاً اختيار مؤسسة مؤرشفة لعرض تقريرها التاريخي.' : 'ניתן לבחור גם חברה בארכיון לצפייה בדוח ההיסטורי שלה.') }}
                    </div>
                  </div>
                </div>

                <div class="row d-flex justify-content-between ">
                  <div class="col-md-4 mt-2 "  >
                    <h6 class="form-label px-1 " style="color: grey;"> 
                      {{ curentLang === 'en' ? 'Period' : (curentLang === 'ar' ? 'الفترة' : '  תקופה ')}}
                    </h6>
                    <div class="px-1">
                      <select class="form-control px-1 form-select" 
                              style="cursor: pointer;" 
                              [(ngModel)]="selectedPeriod"
                              (change)="filterMonth($event)">
                        <option [value]="1">{{ curentLang === 'en' ? 'Current month' : (curentLang === 'ar' ? 'الشهر الحالي' : 'חודש נוכחי  ') }}</option>
                        <option [value]="2">{{ curentLang === 'en' ? 'Last month' : (curentLang === 'ar' ? 'الشهر الماضي' : '  חודש קודם') }}</option>
                        <option [value]="5">{{ curentLang === 'en' ? 'Last two month' : (curentLang === 'ar' ? ' أخر شهران ' : ' שני חודשים קודמים  ') }}</option>
                        <option [value]="3">{{ curentLang === 'en' ? 'Start of the year' : (curentLang === 'ar' ? 'من بداية العام' : ' מתחילת שנה  ') }}</option>
                        <option [value]="4">{{ curentLang === 'en' ? 'Last year' : (curentLang === 'ar' ? 'العام الماضي' : ' שנה קודמת  ') }}</option>
                        <option [value]="0">{{ curentLang === 'en' ? 'Custom range' : (curentLang === 'ar' ? 'نطاق مخصص' : 'טווח מותאם אישית') }}</option>
                      </select>
                    </div>
                 
                  </div>
                
                  <div class="col-md-4 ">
                    <h6 for="fromDate" class="ml-2" style="color: grey;">
                      {{curentLang === 'en' ? 'From Date' : (curentLang === 'ar' ? 'من تاريخ' : '  מתאריך')}}
                    </h6>
                    <div>
                      <p-calendar 
                        [(ngModel)]="fromDate" 
                        style="display: block; width: 100%;"
                        showIcon="true" 
                        (ngModelChange)="onFromDateChange($event)"
                        formControlName="startDate" 
                        dateFormat="dd/mm/yy"
                        placeholder="DD/MM/YYYY"
                        [showButtonBar]="true"
                        [showClear]="true"
                        [readonlyInput]="false"
                        [touchUI]="false"
                        [showWeek]="false"
                        [locale]="curentLang === 'ar' ? 'ar' : (curentLang === 'he' ? 'he' : 'en')"
                        [disabled]="false">
                      </p-calendar>
                      <div *ngIf="reportsForm.get('startDate')?.invalid && reportsForm.get('startDate')?.touched" 
                           class="text-danger small mt-1">
                        {{curentLang === 'ar' ? 'تاريخ البداية مطلوب' : (curentLang === 'en' ? 'Start date is required' : 'תאריך התחלה נדרש')}}
                      </div>
                    </div>
                  </div>
              
                    <div class="col-md-4">
                      <h6 for="toDate"  style="color: grey;">
                       {{curentLang === 'en' ? 'To Date' : (curentLang === 'ar' ? 'الي تاريخ' : ' עד תאריך  ')}}
                     </h6>
                     <div>
                     <p-calendar 
                       style="display: block; width: 100%;"
                       [(ngModel)]="toDate" 
                       showIcon="true" 
                       (ngModelChange)="onToDateChange($event)" 
                       formControlName="endDate" 
                       dateFormat="dd/mm/yy" 
                       placeholder="DD/MM/YYYY"
                       [showButtonBar]="true"
                       [showClear]="true"
                       [readonlyInput]="false"
                       [touchUI]="false"
                       [showWeek]="false"
                       [locale]="curentLang === 'ar' ? 'ar' : (curentLang === 'he' ? 'he' : 'en')"
                       [disabled]="false">
                     </p-calendar>
                     <div *ngIf="reportsForm.get('endDate')?.invalid && reportsForm.get('endDate')?.touched" 
                          class="text-danger small mt-1">
                       {{curentLang === 'ar' ? 'تاريخ النهاية مطلوب' : (curentLang === 'en' ? 'End date is required' : 'תאריך סיום נדרש')}}
                     </div>
                    </div>
                 </div>
                  
                 
                  
                   
                  
                  <div class="col-md-12 mt-4 " style="padding-top: 6px;">
                    <div class="form-group search">
                      <button class="btn btn-sm mx-1 mt-2" 
                              style="background-color: #141414; color: #fff;" 
                              [disabled]="reportsForm.invalid || !CompanyId"
                              (click)="confirmAction()">
                        <i class="fa fa-download mx-1"></i>
                        {{curentLang === 'en' ? 'Download Reports' : (curentLang === 'ar' ? 'تحميل التقارير' : 'הורד דוחות')}}
                      </button>
                      <div *ngIf="!CompanyId" class="text-warning small mt-2">
                        <i class="fa fa-exclamation-triangle mx-1"></i>
                        {{curentLang === 'ar' ? 'يرجى اختيار المصلحة التجارية أولاً' : (curentLang === 'en' ? 'Please select a company first' : 'אנא בחר חברה תחילה')}}
                      </div>
                    </div>
                  </div>
                </div>
                   
                   
                  
                    </form>
              
                 
              
          </div>
          
        </div>
      
      </div>
  </div>
 
</ng-template>

<!-- Archive Confirmation Modal -->
<ng-template #archiveConfirm let-modal>
  <div class="modal-header company-modal-header">
    <h6 class="modal-title company-modal-title">
      <i class="fa fa-archive mx-1" style="color:grey;"></i>
      {{ curentLang === 'en' ? 'Archive Company' : (curentLang === 'ar' ? 'أرشفة المؤسسة' : 'העברה לארכיון') }}
    </h6>
    <button type="button" class="close btn-close company-modal-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body company-modal-body text-center py-4">
    <i class="fa fa-archive fa-3x mb-3" style="color:#141414;opacity:0.15;"></i>
    <p class="mb-1 fw-semibold" style="font-size:0.95rem;color:#111827;">
      {{ curentLang === 'en' ? 'Are you sure you want to archive this company?' : (curentLang === 'ar' ? 'هل أنت متأكد من أرشفة هذه المؤسسة؟' : 'האם אתה בטוח שברצונך להעביר חברה זו לארכיון?') }}
    </p>
    <p style="color:#6b7280;font-size:12px;margin:6px 0 0;">
      {{ curentLang === 'en' ? 'The company will be hidden from active lists. All data and documents are preserved.' : (curentLang === 'ar' ? 'ستُخفى المؤسسة من القوائم النشطة. جميع البيانات والفواتير محفوظة.' : 'החברה תוסתר מהרשימות הפעילות. כל הנתונים והמסמכים נשמרים.') }}
    </p>
  </div>
  <div class="modal-footer justify-content-center gap-2" style="border-top:1px solid #eceff3;">
    <button type="button" class="company-btn-secondary" (click)="modal.dismiss()">
      {{ curentLang === 'en' ? 'Cancel' : (curentLang === 'ar' ? 'إلغاء' : 'ביטול') }}
    </button>
    <button type="button" class="company-btn-primary" (click)="archiveCompany()">
      <i class="fa fa-archive me-1"></i>
      {{ curentLang === 'en' ? 'Archive' : (curentLang === 'ar' ? 'أرشفة' : 'ארכיון') }}
    </button>
  </div>
</ng-template>

<!-- Restore Confirmation Modal -->
<ng-template #restoreConfirm let-modal>
  <div class="modal-header company-modal-header">
    <h6 class="modal-title company-modal-title">
      <i class="fa fa-undo mx-1" style="color:grey;"></i>
      {{ curentLang === 'en' ? 'Restore Company' : (curentLang === 'ar' ? 'إعادة تفعيل المؤسسة' : 'שחזור חברה') }}
    </h6>
    <button type="button" class="close btn-close company-modal-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body company-modal-body text-center py-4">
    <i class="fa fa-undo fa-3x mb-3" style="color:#141414;opacity:0.15;"></i>
    <p class="mb-1 fw-semibold" style="font-size:0.95rem;color:#111827;">
      {{ curentLang === 'en' ? 'Are you sure you want to restore this company?' : (curentLang === 'ar' ? 'هل أنت متأكد من إعادة تفعيل هذه المؤسسة؟' : 'האם אתה בטוח שברצונך לשחזר חברה זו?') }}
    </p>
    <p style="color:#6b7280;font-size:12px;margin:6px 0 0;">
      {{ curentLang === 'en' ? 'The company will appear again in active lists. A subscription slot will be consumed.' : (curentLang === 'ar' ? 'ستظهر المؤسسة مجدداً في القوائم النشطة. سيُستهلك slot من الاشتراك.' : 'החברה תופיע שוב ברשימות הפעילות. תחריב חלון מנוי.') }}
    </p>
  </div>
  <div class="modal-footer justify-content-center gap-2" style="border-top:1px solid #eceff3;">
    <button type="button" class="company-btn-secondary" (click)="modal.dismiss()">
      {{ curentLang === 'en' ? 'Cancel' : (curentLang === 'ar' ? 'إلغاء' : 'ביטול') }}
    </button>
    <button type="button" class="company-btn-primary" (click)="restoreCompany()">
      <i class="fa fa-undo me-1"></i>
      {{ curentLang === 'en' ? 'Restore' : (curentLang === 'ar' ? 'إعادة تفعيل' : 'שחזור') }}
    </button>
  </div>
</ng-template>

<ng-template #moreInfoModal let-modal>
  <div class="modal-header company-modal-header">
    <h6 class="modal-title company-modal-title company-more-info-title">
      {{ curentLang === 'en' ? 'Additional information about the company' : (curentLang === 'ar' ? 'معلومات اضافية عن المصلحة التجارية' : 'מידע נוסף על החברה') }}
      <span *ngIf="moreInfoCompanyName" class="company-more-info-heading-name">{{ moreInfoCompanyName }}</span>
    </h6>
    <button type="button" class="close btn-close company-modal-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body company-modal-body">
    <p *ngIf="moreInfoLoading" class="company-more-info-status">
      {{ curentLang === 'en' ? 'Loading…' : (curentLang === 'ar' ? 'جارٍ التحميل…' : 'טוען…') }}
    </p>
    <p *ngIf="!moreInfoLoading && moreInfoLoadFailed" class="company-more-info-status">
      {{ curentLang === 'en' ? 'Could not load company information.' : (curentLang === 'ar' ? 'تعذر تحميل معلومات المصلحة التجارية.' : 'לא ניתן לטעון את פרטי החברה.') }}
    </p>
    <dl class="company-more-info" *ngIf="!moreInfoLoading && !moreInfoLoadFailed">
      <div class="company-more-info-row">
        <dt>{{ curentLang === 'en' ? 'Company Name' : (curentLang === 'ar' ? 'أسم المصلحة التجارية' : 'שם החברה') }}</dt>
        <dd>{{ displayValue(moreInfoCompanyFieldName()) }}</dd>
      </div>
      <div class="company-more-info-row">
        <dt>{{ curentLang === 'en' ? 'Tax Registration Number' : (curentLang === 'ar' ? 'رقم السجل الضريبي' : 'מספר רישום מס') }}</dt>
        <dd class="ltr-value">{{ displayValue(moreInfoData?.companyInfo?.tax_register) }}</dd>
      </div>
      <div class="company-more-info-row">
        <dt>{{ curentLang === 'en' ? 'Commercial Register' : (curentLang === 'ar' ? 'رقم السجل التجاري' : 'מרשם מסחרי') }}</dt>
        <dd class="ltr-value">{{ displayValue(moreInfoData?.companyInfo?.commercial_register) }}</dd>
      </div>
      <div class="company-more-info-row">
        <dt>{{ curentLang === 'en' ? 'Last Invoice Date' : (curentLang === 'ar' ? 'تاريخ آخر فاتورة' : 'תאריך החשבונית האחרונה') }}</dt>
        <dd class="ltr-value">{{ moreInfoData?.lastInvoice?.invoice_date ? (moreInfoData.lastInvoice.invoice_date | date:'dd/MM/yyyy') : '—' }}</dd>
      </div>
      <div class="company-more-info-row">
        <dt>{{ curentLang === 'en' ? 'Company Accountant Office' : (curentLang === 'ar' ? 'مكتب محاسب المصلحة التجارية' : 'משרד מנהל החשבונות') }}</dt>
        <dd>{{ displayValue(moreInfoData?.officeCompany?.office_name) }}</dd>
      </div>
      <div class="company-more-info-row">
        <dt>{{ curentLang === 'en' ? 'Phone Company Accountant' : (curentLang === 'ar' ? 'هاتف محاسب المصلحة التجارية' : 'מס טלפון מנהל החשבונות') }}</dt>
        <dd class="ltr-value">{{ displayValue(moreInfoData?.officeCompany?.office_phone) }}</dd>
      </div>
      <div class="company-more-info-row">
        <dt>{{ curentLang === 'en' ? 'Office Address' : (curentLang === 'ar' ? 'عنوان المكتب' : 'כתובת המשרד') }}</dt>
        <dd>{{ displayValue(moreInfoData?.officeCompany?.office_address) }}</dd>
      </div>
      <div class="company-more-info-row">
        <dt>{{ curentLang === 'en' ? 'Merchant Name' : (curentLang === 'ar' ? 'أسم التاجر' : 'שם סוחר') }}</dt>
        <dd>{{ displayValue(moreInfoMerchantName()) }}</dd>
      </div>
      <div class="company-more-info-row">
        <dt>{{ curentLang === 'en' ? 'Merchant Phone' : (curentLang === 'ar' ? 'هاتف التاجر' : 'טלפון סוחר') }}</dt>
        <dd class="ltr-value">{{ displayValue(moreInfoMerchantPhone()) }}</dd>
      </div>
    </dl>
  </div>
  <div class="modal-footer justify-content-center" style="border-top:1px solid #eceff3;">
    <button type="button" class="company-btn-secondary" (click)="modal.dismiss()">
      {{ curentLang === 'en' ? 'Close' : (curentLang === 'ar' ? 'إغلاق' : 'סגור') }}
    </button>
  </div>
</ng-template>